/**
 * SensiActivityCard - Clickable activity card for chat responses
 * Links to activity detail page when clicked
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icons } from '../../lib/Icons';

const SensiActivityCard = ({ activity }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (activity.slug) {
      navigate(`/solo/activity/${activity.slug}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full text-left p-3 rounded-xl bg-gradient-to-r from-violet-500/10 to-purple-500/10 border border-violet-500/20 hover:border-violet-500/40 hover:from-violet-500/20 hover:to-purple-500/20 transition-all group"
    >
      <div className="flex items-start gap-3">
        {/* Icon */}
        <div className="w-10 h-10 rounded-lg bg-violet-500/20 flex items-center justify-center flex-shrink-0 group-hover:bg-violet-500/30 transition-colors">
          <Icons.Puzzle className="w-5 h-5 text-violet-400" />
        </div>
        
        {/* Content */}
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-white text-sm group-hover:text-violet-300 transition-colors truncate">
            {activity.title}
          </h4>
          {activity.description && (
            <p className="text-xs text-slate-400 mt-0.5 line-clamp-2">
              {activity.description}
            </p>
          )}
        </div>

        {/* Arrow */}
        <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          <Icons.ChevronRight className="w-4 h-4 text-violet-400" />
        </div>
      </div>
    </button>
  );
};

export default SensiActivityCard;



